export default __webpack_public_path__ + "static/media/people.1338f1ac.svg";